import WorksiteTask from '../models/WorksiteTask';
import BaseCollection from '@spa/apps/trustup-pro-base-js/collections/BaseCollection';

export default class WorksiteTaskCollection extends BaseCollection
{

    constructor(items, group)
    {
        super(items, {
            modelClass: WorksiteTask
        });

        this.group = group;
    }

    itemShouldBeInCollection(item)
    {
        console.log('Check item', item, this.group);
        return item.group_id == this.group.id;
    } 

}